(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["hf-faq"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', (event) => {
const details = document.querySelectorAll('details');
details.forEach((detail) => {
detail.addEventListener('toggle', (event) => {
if (detail.open) {
const icon = detail.querySelector('svg');
icon.style.transform = 'rotate(180deg)';
} else {
const icon = detail.querySelector('svg');
icon.style.transform = 'rotate(0deg)';
}
});
});
});

  } catch(e) { console.error(e); }
})();
      })();
